// extracted by mini-css-extract-plugin
module.exports = {"size__wrapper":"size__wrapper-16-vH","weight":"weight-2W81U","name":"name-3qcq5","measurement":"measurement-2w5cl","price__wrp":"price__wrp-1bGnE","price":"price-1Avee"};